import { forwardRef } from 'react';
import { Badge } from '../Badge/Badge';
import type { BadgeColor } from '../Badge/Badge';
import { Button } from './Button';
import type { ButtonProps } from './Button.types';
import './ButtonBadged.css';

export type ButtonBadgedProps = ButtonProps & {
  /** Whether the badge is visible. When false the button renders without a badge overlay. */
  badgeVisible?: boolean;
  /** Numeric count shown inside the badge. */
  badgeAmount?: string;
  /** Semantic color of the badge overlay. Defaults to `critical`. */
  badgeColor?: BadgeColor;
};

/**
 * Button with an optional Badge overlay.
 *
 * The badge is absolutely positioned on a separate layer so it never
 * changes the button's dimensions, even when it exceeds the button boundaries.
 */
export const ButtonBadged = forwardRef<HTMLButtonElement, ButtonBadgedProps>(
  function ButtonBadged(
    { badgeVisible = false, badgeAmount, badgeColor, className = '', ...buttonProps },
    ref,
  ) {
    return (
      <div className="spark-btn-badged-wrap">
        <Button ref={ref} className={className} {...buttonProps} />
        {badgeVisible && <Badge amount={badgeAmount} color={badgeColor} />}
      </div>
    );
  },
);

ButtonBadged.displayName = 'ButtonBadged';
